import { ArrowCircleRight } from "@mui/icons-material";
import { Box, Card, CardContent, Chip, IconButton, Tooltip } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import { CustomDescrypt } from "global/func";
import { postDataWithResponse } from "global/postFunc";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useState } from "react";
import { Link, Route, Routes } from "react-router-dom"
import userStore from "store/userStore";
import Detail from "./Detail";
import RincianBelanja from "./RincianBelanja";
import Komponen from "./Komponen";
import { decodeToken } from "react-jwt";


const Laporan = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="detail" element={<Detail />} />
            <Route path="rincian-belanja" element={<RincianBelanja />} />
            <Route path="komponen" element={<Komponen />} />
        </Routes>
    )
}

const Data = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [loading, setLoading] = useState(false)

    const [listOpd, setListOpd] = useState([])

    const reqOpd = () => {
        const decodedUser = decodeToken(decryptedUser);
        setLoading(true)
        addReq()
        postDataWithResponse(
            '/a-pemb/check-laporan-opd',
            {
                ta: tahunAnggaran.ta,
                user: decodedUser.username
            },
            decryptedUser,
            (res) => {
                console.log(res);
                setListOpd(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqOpd()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns = [
        {
            accessorKey: 'nama_pd',
            header: 'OPD',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontWeight='bold'
                        fontSize='small'
                        variant="inherit"
                    >
                        {cell.row.original.kd_pd} {cell.getValue()}
                    </ArgonTypography>
                    {
                        cell.row.original.anggaran_terinput === cell.row.original.anggaran_opd ?
                            <Chip size='small' label='Input Perencanaan Selesai' color='success' variant="outlined" />
                            :
                            <Chip size='small' label='Input Perencanaan belum Selesai' color='error' variant="outlined" />
                    }
                    {
                        cell.row.original.anggaran_terinput === cell.row.original.anggaran_opd ?
                            cell.row.original.blm_dilaporkan === 0 ?
                                <Chip size='small' label='Input Laporan Selesai' color='success' variant="outlined" />
                                :
                                <Chip size='small' label={cell.row.original.blm_dilaporkan + ' Komponen belum Melapor'} color='error' variant="outlined" />
                            :
                            <Chip size='small' label='Input Laporan belum Selesai' color='error' variant="outlined" />
                    }
                </>
            )
        },
        {
            accessorKey: 'anggaran_opd',
            header: 'Anggaran',
            Cell: ({ cell }) => (
                <ArgonTypography
                    variant="inherit"
                    fontSize="small"
                >
                    {
                        parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        })
                    }
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'komponen_terinput',
            header: 'Komponen Belanja',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        variant="inherit"
                        fontSize="small"
                    >
                        {cell.getValue()} Komponen
                    </ArgonTypography>
                    <ArgonTypography
                        variant="inherit"
                        fontSize="small"
                    >
                        {
                            parseInt(cell.row.original.anggaran_terinput)?.toLocaleString?.('id-ID', {
                                style: 'currency',
                                currency: 'IDR',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })
                        }
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'realisasi_keuangan',
            header: 'Realisasi Keuangan',
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        variant="inherit"
                        fontSize="small"
                    >
                        {
                            parseInt(cell.getValue())?.toLocaleString?.('id-ID', {
                                style: 'currency',
                                currency: 'IDR',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            })
                        }
                    </ArgonTypography>
                    <ArgonTypography
                        variant="inherit"
                        fontSize="small"
                    >
                        {parseFloat(cell.row.original.realisasi_keuangan_persen).toFixed(2)}%
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'realisasi_fisik_terbobot',
            header: 'Realisasi Fisik',
            Cell: ({ cell }) => (
                <ArgonTypography
                    variant="inherit"
                    fontSize="small"
                >
                    {cell.getValue().toFixed(2)}%
                </ArgonTypography>
            )
        },
    ];

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={1}>
                <Card>
                    <CardContent>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center" py={2}>
                            <ArgonTypography variant="h6">Tabel Pelaporan OPD</ArgonTypography>
                        </ArgonBox>
                        <ArgonBox
                            sx={{
                                "& .MuiTableRow-root:not(:last-child)": {
                                    "& td": {
                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                            `${borderWidth[1]} solid ${borderColor}`,
                                    },
                                },
                            }}
                            spacing={2}
                        >

                            <MaterialReactTable
                                columns={columns}
                                data={listOpd}
                                // enableExpanding
                                // enableExpandAll
                                muiTableHeadCellProps={{
                                    sx: {
                                        fontSize: '0.875rem !important',
                                        color: 'text.main !important'
                                    }
                                }}
                                muiTableFooterCellProps={{
                                    sx: {
                                        fontSize: '0.875rem !important',
                                        color: 'text.main !important'
                                    }
                                }}
                                muiTopToolbarProps={{
                                    sx: { fontSize: '0.875rem' }
                                }}
                                initialState={{
                                    expanded: true
                                }}
                                enablePagination={false}
                                enableColumnFilters={false}
                                enableSorting={true}
                                state={{ isLoading: loading }}
                                enableRowActions={true}
                                positionActionsColumn='first'
                                displayColumnDefOptions={{
                                    'mrt-row-actions': {
                                        header: 'Action', //change header text
                                        size: 5, //make actions column wider
                                        alignment: 'left'
                                    }
                                }}
                                renderRowActions={({ row }) => [
                                    <Box key={row.original.kd_pd}>
                                        <Tooltip title="Detail Laporan">
                                            <IconButton
                                                id="basic-button"
                                                color='primary'
                                                component={Link}
                                                to='/a-pemb/laporan/detail'
                                                state={row.original}
                                            >
                                                <ArrowCircleRight fontSize='small' />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                ]}
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default Laporan